import { render, staticRenderFns } from "./InSwitchLEDR6.vue?vue&type=template&id=fb90527a&scoped=true&"
import script from "./InSwitchLEDR6.vue?vue&type=script&lang=js&"
export * from "./InSwitchLEDR6.vue?vue&type=script&lang=js&"
import style0 from "./InSwitchLEDR6.vue?vue&type=style&index=0&id=fb90527a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb90527a",
  null
  
)

export default component.exports